import { Typography, TypographyProps } from "@mui/material";
import { FC } from "react";
import { FontMap } from "../salify-next-layout/default/theme/font-family/font-family";

interface SalifyTypographyProps {
  text: any;
  cssProps?: TypographyProps;
}

const SalifyTypography: FC<SalifyTypographyProps> = (props) => {
  return (
    <Typography
      {...props.cssProps}
      fontFamily={
        typeof props.cssProps?.fontFamily === "string" &&
        FontMap[props.cssProps.fontFamily as keyof typeof FontMap]
          ? FontMap[props.cssProps!.fontFamily as keyof typeof FontMap]
          : undefined
      }
    >
      {props.text}
    </Typography>
  );
};

SalifyTypography.displayName = "SalifyTypography";

export default SalifyTypography;
